import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { removeEmpty, useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Event } from 'utils/types';
import { useTour } from '@reactour/tour';
import partialConstants from 'ui/partials/utils/constants';

import contactsConstants from '../../contact/utils/constants';
import c from '../utils/constants';
import { EVENT_FORM } from '../forms/schema';

interface Payload extends EVENT_FORM {
  dealId?: string;
  startAt: string;
  endAt: string;
}

export default function useCreateEvent(params = {}) {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const { isOpen, setIsOpen } = useTour();
  const args = state;

  return useMutation<Event, ApiError, Payload, any>({
    mutationFn: async (payload) => {
      if (isOpen) return setIsOpen(false);

      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: '/api/v1/calendar/events',
            payload: removeEmpty(payload),
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/calendar/events`,
            payload: removeEmpty(payload),
          },
        }),
      );

      return data;
    },
    onSuccess: (successData: any) => {
      const { data } = successData ?? {};
      const { dealId } = data ?? {};

      queryClient.invalidateQueries({ queryKey: [c.EVENTS, params] });
      queryClient.invalidateQueries({ queryKey: [c.EVENT_SUMMARY] });
      queryClient.invalidateQueries({
        queryKey: [contactsConstants.LEADS],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      if (dealId) {
        queryClient.invalidateQueries({ queryKey: [c.LOGS, dealId] });
      }

      toastSuccess('Successfully created new event.');
    },
  });
}
